import type { Label } from "@/api";
import { normalizeLabelText } from "./labelText";

// 자유 입력 value 에 표시할 기존 라벨 제안(같은 key 의 카탈로그 값). 색은 칩과 토큰 표시에 쓰고,
// 설명은 고를 때 표시하는 보조 줄이다. task 처럼 열린 축의 값은 사람이 정한 문자열이라 FE 가
// 문구를 소유할 수 없다. 라벨마다 서버의 `description`(Labels 화면에서 편집)이 SoT 다.
export type ReservedValueSuggestion = {
  value: string;
  color: number;
  description: string | null;
};

// 카탈로그에서 주어진 key 의 라벨 값을 중복 없이 모은다(카탈로그 순서 유지). key 가 비면 빈 목록이다.
//
// key 는 정규화해서 비교한다. 서버가 (key,value) 를 `strip().lower()` canonical 형태로 저장하므로
// `Camera_Rig` 와 `camera_rig` 는 같은 축이다. 여기만 대소문자를 구분하면 새 라벨 창이 "이 key 에
// 쓰인 기존 값이 없습니다" 와 "이미 있는 라벨입니다" 를 함께 표시한다. 다른 판정은 모두 정규화한다.
export function deriveLabelSuggestions(
  catalog: readonly Label[],
  key: string,
): ReservedValueSuggestion[] {
  const normalizedKey = normalizeLabelText(key);
  if (normalizedKey === "") {
    return [];
  }
  const seen = new Set<string>();
  const result: ReservedValueSuggestion[] = [];
  for (const label of catalog) {
    if (normalizeLabelText(label.key) !== normalizedKey || seen.has(label.value)) {
      continue;
    }
    seen.add(label.value);
    result.push({ value: label.value, color: label.color, description: label.description });
  }
  return result;
}

// 현재 입력값으로 제안을 좁힌다. 정확히 일치하는 값은 뺀다(이미 그 값이라 더할 것이 없다).
// 부분 일치(대소문자 무시)만 limit 개까지 남긴다. 입력이 비면 전체를 limit 개까지 표시한다.
export function filterLabelSuggestions(
  suggestions: readonly ReservedValueSuggestion[],
  value: string,
  limit: number,
): ReservedValueSuggestion[] {
  const query = value.trim().toLowerCase();
  return suggestions
    .filter((suggestion) => {
      const candidate = suggestion.value.toLowerCase();
      return candidate !== query && (query === "" || candidate.includes(query));
    })
    .slice(0, limit);
}
